import { useState } from 'react';
import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';
import { useAuthStore } from '@/store/authStore';
import { useUIStore } from '@/store/uiStore';

const DEFAULT_USER_ID = 524710129;

export function DebugLoginScreen() {
  const setDebugUser = useAuthStore((s) => s.setDebugUser);
  const setScreen = useUIStore((s) => s.setScreen);
  const [userId, setUserId] = useState(String(DEFAULT_USER_ID));
  const [username, setUsername] = useState('debug_user');

  const submit = () => {
    const id = Number(userId);
    if (!Number.isFinite(id) || id <= 0) return;
    setDebugUser(id, username.trim() || 'debug_user');
    setScreen('loading');
  };

  return (
    <div className="flex-1 overflow-y-auto flex items-center justify-center p-6">
      <Card className="w-full max-w-sm p-6 space-y-4">
        <div>
          <h1 className="font-display text-2xl text-white">Debug Login</h1>
          <p className="text-sm text-white/50 mt-1">
            You opened the app outside Telegram. Enter a fake user ID to continue.
          </p>
        </div>
        <label className="block space-y-1">
          <span className="text-sm text-white/70">User ID</span>
          <input
            className="input"
            type="number"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            inputMode="numeric"
          />
        </label>
        <label className="block space-y-1">
          <span className="text-sm text-white/70">Username</span>
          <input
            className="input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </label>
        <Button fullWidth onClick={submit}>
          Enter game
        </Button>
      </Card>
    </div>
  );
}
